function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import React, { forwardRef } from "react";
import { injectTestId } from "@cvent/nucleus-test-automation";
import RadioButton from "./components/RadioButton";
import useStyle from "./RadioGroup.style";
var RadioGroup = forwardRef(function(_param, ref) {
    var accessibilityLabel = _param.accessibilityLabel, describedBy = _param.describedBy, disabled = _param.disabled, hasError = _param.hasError, id = _param.id, inline = _param.inline, isRtl = _param.isRtl, name = _param.name, onChange = _param.onChange, onUpdate = _param.onUpdate, options = _param.options, required = _param.required, selected = _param.selected, _style = _param.style, testID = _param.testID, restProps = _objectWithoutProperties(_param, [
        "accessibilityLabel",
        "describedBy",
        "disabled",
        "hasError",
        "id",
        "inline",
        "isRtl",
        "name",
        "onChange",
        "onUpdate",
        "options",
        "required",
        "selected",
        "style",
        "testID"
    ]);
    var groupStyles = useStyle({
        isRtl: isRtl
    });
    var _$ref, _$ref1;
    return _jsx("div", _objectSpread({}, restProps, {
        "aria-describedby": (_$ref = restProps === null || restProps === void 0 ? void 0 : restProps['aria-describedby']) !== null && _$ref !== void 0 ? _$ref : describedBy,
        "aria-label": (_$ref1 = restProps === null || restProps === void 0 ? void 0 : restProps['aria-label']) !== null && _$ref1 !== void 0 ? _$ref1 : accessibilityLabel,
        css: groupStyles,
        id: id,
        ref: ref,
        role: "radiogroup"
    }, injectTestId(testID), {
        children: options.map(function(rb, i) {
            if (!(typeof rb === 'string' || typeof rb === 'number')) {
                return _jsx(RadioButton, {
                    id: id ? "".concat(id, "__").concat(name, "__").concat(i) : "".concat(name, "__").concat(i),
                    name: name,
                    required: required && !disabled,
                    option: _objectSpread({}, rb, {
                        checked: rb.value === selected || false,
                        disabled: disabled || rb.disabled
                    }),
                    testID: testID,
                    inline: inline,
                    hasError: hasError,
                    isRtl: isRtl,
                    onChange: onChange,
                    onUpdate: onUpdate
                }, "".concat(name, "__").concat(i));
            }
            return _jsx(RadioButton, {
                id: id ? "".concat(id, "__").concat(name, "__").concat(i) : "".concat(name, "__").concat(i),
                name: name,
                required: required && !disabled,
                option: {
                    value: rb,
                    label: rb,
                    checked: rb === selected || false,
                    disabled: disabled
                },
                testID: testID,
                inline: inline,
                hasError: hasError,
                isRtl: isRtl,
                onChange: onChange,
                onUpdate: onUpdate
            }, "".concat(name, "__").concat(i));
        })
    }));
});
export { RadioGroup };
export default RadioGroup;
